import { IOperationResultNoValue, ITagAlert } from '@ViewModels';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import {
	ErrorMessagesViewModelKey,
	IErrorMessageComponentProps,
	IUserSessionComponentProps,
	UserSessionViewModelKey,
} from '../../../models/AppState';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { Modal } from '../../../web/components/Modal';
import { GenerateTagNotificationsReport } from '../../../web/components/reporting/tags/GenerateTagNotificationsReport';
import './styles.less';

interface IProps extends IUserSessionComponentProps, IErrorMessageComponentProps {
	accountId: string;
	className?: string;
	isOpen?: boolean;
	onRequestClose?: any;
}

interface IState {
	showLoader?: boolean;
	tagAlerts?: ITagAlert[];
}

class _AssessmentReport extends React.Component<IProps> {
	private checkJobStatusTimeOutRef: any;

	public state: IState = {
		showLoader: false,

		tagAlerts: null,
	};

	public componentWillUnmount() {
		if (this.checkJobStatusTimeOutRef) {
			clearTimeout(this.checkJobStatusTimeOutRef);
		}
	}

	public componentDidMount() {
		// Show loader and call web service to tag a list of tag alerts
		this.loadTagsWithAlerts();
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
		if (this.props.isOpen !== nextProps.isOpen) {
			// Clear out the old state
			this.setState({
				jobFinished: false,
				reportJob: null,
				reportJobId: null,
				selectedTagAlertId: null,
			});
		}
	}

	private loadTagsWithAlerts = () => {
		this.props.userSession.webServiceHelper.callWebServiceWithOperationResults<ITagAlert[]>(
			'admin/tagAlertsOperations/?accountId=' + this.props.accountId,
			'GET',
			null,

			result => this.loadTagsSuccess(result.value),
			result => this.loadTagsError(result)
		);

		this.setState({ showLoader: true });
	};

	private loadTagsSuccess = (tagAlerts: ITagAlert[]) => {
		this.setState({ showLoader: false, tagAlerts });
	};

	private loadTagsError = (error: IOperationResultNoValue) => {
		const { errorMessages } = this.props;

		errorMessages.pushApiError(error);

		this.setState({ showLoader: false });
	};

	private renderGenerateReportContent() {
		// Loop through the users and format all of them
		return !!this.state.tagAlerts && this.state.tagAlerts.length > 0 ? (
			<GenerateTagNotificationsReport accountId={this.props.accountId} title='Tag Assessment Report' />
		) : (
			<div>There are no tag alerts on this account.</div>
		);
	}

	public render() {
		return (
			<Modal
				className={this.props.className || 'assessmentReportModalWrapper'}
				isOpen={!!this.props.isOpen}
				onRequestClose={this.onClose}
				useDefaultHeader={true}
			>
				<>
					{!this.state.showLoader && this.renderGenerateReportContent()}
					{!!this.state.showLoader && <LoadingSpinner type='small' />}
				</>
			</Modal>
		);
	}

	private onClose = () => {
		if (this.props.onRequestClose) {
			this.props.onRequestClose();
		}
	};
}

const AssessmentReportAsObserver = observer(_AssessmentReport);
export const AssessmentReport = inject(UserSessionViewModelKey, ErrorMessagesViewModelKey)(AssessmentReportAsObserver);
